import React, { useState, useEffect } from "react";
import {
    Modal,
    Form,
    Button,
    CloseButton,
    Alert,
    Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import "../styles/AuthModal.css";
import { resendEmailVerification } from "../Api/authApi";

const ResendVerificationModal = ({ show, handleClose, initialEmail }) => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Reset form data when modal is closed or opened
    useEffect(() => {
        if (show) {
            if (initialEmail) {
                setEmail(initialEmail);
            }
        } else {
            setEmail("");
            setError("");
            setLoading(false);
        }
    }, [show, initialEmail]);

    // Handle input change
    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    // Handle submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await resendEmailVerification(email);
            toast.success(res.detail || "Verification email sent!");
            handleClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="custom-modal-size"
            contentClassName="auth-modal-content"
        >
            <Modal.Body className="auth-modal-body">
                <CloseButton onClick={handleClose} className="close-btn" />

                <div className="heading text-center mb-4">
                    <h1 className="title">Resend Verification</h1>
                    <h5 className="subtitle">
                        Enter your email and we'll send you a link to verify your account.
                    </h5>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="resendEmail">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter your email"
                            onChange={handleChange}
                            value={email}
                            required
                        />
                    </Form.Group>

                    <Button
                        type="submit"
                        className="btn-gradient w-100 mb-3"
                        disabled={loading}
                    >
                        {loading ? <Spinner size="sm" /> : "Resend Link"}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ResendVerificationModal;
